import { PageSection } from './bookings'
import { i18nService } from '@accor/customer-vue-services'
import { computed } from 'vue'

const locale = computed(() => i18nService.getCurrentLocale())

export const GTM_MENU_ITEM = (id: string) => ({
  event: 'GAevent',
  eventCategory: 'account',
  eventLabel: id,
  eventAction: 'menu - click on cta'
})

/* ACCOUNT PAGE MY BOOKING  --------------- */

export const GTM_PAGE_MY_BOOKINGS = () => ({
  category: 'account',
  pageName: 'account::bookings',
  sub_category_level1: 'bookings',
  virtual_page_path: `/account/${locale.value}/my-bookings`
})

export const GTM_ONLINE_CHECK_IN = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'check in online'
})

export const GTM_SEE_DETAILS_BOOKINGS = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'see the details'
})

export const GTM_BOOK_AGAIN = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'book again'
})

export const GTM_HOTEL_FACTSHEET_NAME = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'hotel factsheet name'
})

export const GTM_SEARCH_HOTEL = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'search an hotel'
})

export const GTM_SEE_OLD_RESERVATIONS = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'see my old reservations'
})

export const GTM_SEE_MORE_BOOKINGS = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'see more'
})

export const GTM_ID_MY_BOOKINGS_FEVER_CTA = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'see details - activities'
})

export const GTM_ID_MY_BOOKINGS_KARHOO_CTA = () => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'see details - karhoo'
})

export const GTM_ID_MY_BOOKINGS_TAB_CTA = (tab: string) => ({
  eventAction: 'my bookings - click on cta',
  eventCategory: 'account',
  eventLabel: {
    [PageSection.Hotel]: 'stays',
    [PageSection.Mobility]: 'trips',
    [PageSection.Experience]: 'activities'
  }[tab]
})

export const GTM_REQUEST_INVOICE = () => ({
  eventAction: 'homepage - bookings - click on cta',
  eventCategory: 'account',
  eventLabel: 'ask your invoice'
})

/** GLOBAL TRANSACTION HISTORY PAGE **/

export const GTM_ACCOUNT_ACTIVITY = () => ({
  pageName: 'account::activity',
  category: 'account',
  sub_category_level1: 'rewards'
})

export const GTM_CREDIT_LEARN_MORE = () => ({
  eventCategory: 'account',
  eventAction: 'account activity - click on cta',
  eventLabel: 'learn more'
})

export const GTM_HOW_TO_EARN_POINTS = () => ({
  eventCategory: 'account',
  eventAction: 'account activity - click on cta',
  eventLabel: 'how to earn points'
})

export const GTM_FIND_A_HOTEL = () => ({
  eventCategory: 'account',
  eventAction: 'account activity - click on cta',
  eventLabel: 'find a hotel'
})

export const GTM_HOW_TO_USE_POINTS = () => ({
  eventCategory: 'account',
  eventAction: 'account activity - click on cta',
  eventLabel: 'how to use points'
})

/** MY LOYALTY PROGRAM PAGE **/
export const GTM_PAGE_LOYALTY = () => ({
  category: 'account',
  pageName: 'account::loyalty',
  sub_category_level1: 'loyalty'
})

export const GTM_REWARDS_POINTS_LEARN_MORE = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your rewards - click on cta',
  eventLabel: 'reward points learn more'
})

export const GTM_EARN_POINTS = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your rewards - click on cta',
  eventLabel: 'earn points'
})

export const GTM_HOW_IT_WORK = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your status - click on cta',
  eventLabel: 'how its works'
})

export const GTM_RECEIVE_MY_CARD = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your status - click on cta',
  eventLabel: 'receive my card'
})

export const GTM_NEED_HELP = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your status - click on cta',
  eventLabel: 'need help'
})

export const GTM_SNU_LEARN_MORE = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your rewards - click on cta',
  eventLabel: 'snu learn more'
})

export const GTM_DIN_LEARN_MORE = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your rewards - click on cta',
  eventLabel: 'din learn more'
})

export const GTM_FAIRMONT_LEARN_MORE = () => ({
  eventCategory: 'account',
  eventAction: 'your rewards - click on cta',
  eventLabel: 'fairmont learn more'
})

export const GTM_HOW_TO_USE_SLIDER_REWARDS = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - slider rewards - click on cta',
  eventLabel: 'how to use'
})

export const GTM_BENEFIT_LEARN_MORE = (benefit: Record<string, string>) => ({
  eventCategory: 'account',
  eventAction: `account loyalty - your major benefits - ${benefit.selectedTab} status -  click on cta`,
  eventLabel: `learn more - ${benefit.name}`
})

export const GTM_SEE_ALL_BENEFITS = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your major benefits - click on cta',
  eventLabel: 'see all benefits'
})

export const GTM_SEE_MORE_DETAILS_PARTNER = (partnerName: string) => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - more points more quickly - click on cta',
  eventLabel: `see more details - ${partnerName}`
})

export const GTM_DISCOVER_OFFER = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - more points more quickly - click on cta',
  eventLabel: 'discover offer'
})

export const GTM_DISCOVER_OTHER_OFFERS = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - more points more quickly - click on cta',
  eventLabel: 'discover other offers'
})

export const GTM_LIMITLESS_ASSISTANCE_CONDITIONS = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your status - limitless - click on cta',
  eventLabel: 'see conditions'
})

export const GTM_LIMITLESS_ASSISTANCE_GET_CARD = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your status - limitless - click on cta',
  eventLabel: 'receive your card'
})

export const GTM_HOW_TO_USE_AWARDS = (data: Record<string, string>) => ({
  eventCategory: 'account',
  eventAction: `account loyalty - slider ${data.award} - click on cta`,
  eventLabel: 'how to use'
})

export const GTM_STATUS_GIFT_OFFER_CONTINUE = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - slider status gift email - click on cta',
  eventLabel: 'continue'
})

export const GTM_STATUS_GIFT = (data: Record<string, string>) => {
  return {
    eventCategory: 'account',
    eventAction: 'account loyalty - slider status gift confirmation - click on cta',
    eventLabel: data.event
  }
}

export const GTM_MEMBER_GIFT_LEARN_MORE = () => ({
  eventCategory: 'account',
  eventAction: 'account loyalty - your rewards - click on cta',
  eventLabel: 'member gift'
})

export const GTM_PAGE_PARTNERS = () => ({
  pageName: 'account::your partner benefits',
  category: 'account',
  sub_category_level1: 'your partner benefits'
})

export const GTM_PAGE_CHANGE_PLAN = () => ({
  category: 'account',
  pageName: 'account::all signature::plan modification',
  sub_category_level1: 'all signature',
  sub_category_level2: 'plan modification'
})

export const GTM_PAGE_INFORMATION = () => ({
  category: 'account',
  pageName: 'account::my information',
  sub_category_level1: 'my information'
})

export const GTM_PAGE_PREFERENCES = () => ({
  category: 'account',
  pageName: 'account::stay preferences',
  sub_category_level1: 'account',
  sub_category_level2: 'stay preferences'
})
